$(document).ready(function () {
  $(".open-popup-link").magnificPopup({
    type: "inline",
    midClick: true, // allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source.
  });

  $(".open-popup-link").click(function () {
    $(".size-popup-header").removeClass("hide-this");
    $(".size-tab").removeClass("active-tab");
    $("#questionnaire").addClass("active-tab");
  });

  $(".tab-link").click(function () {
    $([document.documentElement, document.body]).animate(
      {
        scrollTop: $("#size-popup").offset().top,
      },
      1000
    );
  });

  $(".questionnaire").click(function () {
    $(".tab-link").removeClass("active-tab-link");
    $(this).addClass("active-tab-link");
    $(".size-tab").removeClass("active-tab");
    $("#questionnaire").addClass("active-tab");
  });

  $(".size-chart").click(function () {
    $(".tab-link").removeClass("active-tab-link");
    $(this).addClass("active-tab-link");
    $(".size-tab").removeClass("active-tab");
    $("#size-chart").addClass("active-tab");
  });

  $("#choose-size").on("submit", function (e) {
    e.preventDefault();
    var doglength = $("#length").val();
    var dogheight = $("#height").val();
    var dogweight = $("#weight").val();

    $(".size-tab").removeClass("active-tab");
    $(".size-popup-header").addClass("hide-this");

    if (doglength > 21 || dogheight > 12 || dogweight == 10) {
      $("#db-reco").addClass("active-tab");
    } else {
      $("#db-mini-reco").addClass("active-tab");
    }
  });

  setTimeout(add_btn_Keith_Haring_size, 0);
  function add_btn_Keith_Haring_size() {
    if ($("#doggy-bathroom.template-product .product-variant").length) {
      $(".product-variant").each(function (l) {
        var $this = $(this);
        if ($this.find("select#product-size").length) {
          $this
            .find("ul")
            .append(
              "<li tabindex='0' class='khe-btn' data-text='Keith Haring Edition'><a href='https://ca.doggybathroom.com/collections/keith-haring/products/doggy-bathroom-x-keith-haring-starter-kit'><span class='Keith-Haring-Edition'>Keith Haring Collection</span></a></li>"
            );
        }
      });
    }
  }
  setTimeout(add_explore_Keith_Haring, 0);
  function add_explore_Keith_Haring() {
    if (
      $(".template-product-doggy-bathroom-essentials .product-variant").length
    ) {
      $(".product-variant").each(function () {
        var $this = $(this);
        if ($this.find("#product-colour").length) {
          $this
            .find("ul")
            .append(
              "<span class='Keith-Haring-Edition-Ess'>Explore more colours in our <a href='https://ca.doggybathroom.com/collections/keith-haring/products/doggy-bathroom-x-keith-haring-starter-kit'>Keith Haring Collection</span></a>"
            );
        } 
      });
    }
  }

  /* 
  Add dynamic colour labels to the product form
  Change them when the colour is changed
  Only apply this to the correct template
  */
  handleProductColourText();

  function handleProductColourText() {
    var runOnPage = $("#add-to-cart-product-dbessentials").length;
    var colourLabel = $('[for="product-colour"]');
    var colourSelectInput = $("#product-colour");

    // only run on the right template and if the elements exist
    if (!runOnPage || !colourLabel || !colourSelectInput) {
      return;
    }

    // initially append a section for the dynamic color text
    colourLabel.append(': <span class="colour-text"></span>');

    // place the new colour label text in a variable
    var colourText = $(".colour-text");

    // make the initial update
    labelUpdate();

    // update it every time the product colour changes
    colourSelectInput.on("change", labelUpdate);

    function labelUpdate() {
      if (!colourText || !colourSelectInput.val()) return;

      colourText.text(colourSelectInput.val());
    }
  }

  handleCustomCheckmark();
  
  /* 
  Code for all of the custom checkmarks
  What happens on click is determined by the trigger id
  */
  function handleCustomCheckmark() {
    $('.ex-checkbox-wrapper').each(function(i, el) {
      var currentWrapper = $(el);
      var triggerID = currentWrapper.attr('data-ex-trigger');
      
      currentWrapper.find('input').on('click', function(event){
        var checkBox = this;
        
        var checkboxLabel = $(el).find('.ex-checkbox');

        if(checkBox.checked){
          checkboxLabel.addClass('active');
        }else{
          checkboxLabel.removeClass('active');
        }

        
        if(triggerID === 'product-quantity'){
          handleProductQuantity(currentWrapper, checkBox.checked);
        }
        
      });

      function handleProductQuantity(wrapper, isChecked){

        var qtySelect = $('#product-quantity');
        var qtySelectOptions = $('#product-quantity option');

        qtySelectOptions.each(function(){
          $(this).attr('selected', false);
        })
        
        var currentOption = isChecked ? qtySelectOptions[1] : qtySelectOptions[0];
        
        qtySelect.value = currentOption.value;
        
        $(currentOption).attr('selected', 'selected');
        $(qtySelect).trigger('change');

      }
      
    });
  }

  function handleProductTabs(){
    var allTabs = $('[data-ex-tabs]');

    allTabs.each(function(index, el){
      initTabs(el);
    });

    function initTabs(wrapper){
      var tabLinks = $(wrapper).find('.product-tab-link');

      tabLinks.on('click', function(event){
        event.preventDefault();

        var currentTabID = $(this).attr('data-ex-tab-id');
        var tabToTrigger = $('#' + currentTabID);
        console.log(currentTabID);
        console.log(tabToTrigger);
        console.log($(this));
        
        hideAllTabs();
        
        tabToTrigger.addClass('active');
        $(event.currentTarget).addClass('active');
      });

      function hideAllTabs(){
        var allTabContent = $(wrapper).find('.tabcontent');
        allTabContent.removeClass('active');
        tabLinks.removeClass('active');
      }
      
    }
  }

  handleProductTabs();

});




// Function to execute the script
function executeScript() {
  // Check if the body element has the class "template-product-doggy-bathroom-essentials"
  if ($('body').hasClass('template-product-doggy-bathroom-essentials')) {
    // Check if the class lb-upsell-ppa-card-cont is found
    const upsellCardCont = $('.lb-upsell-ppa-card-cont');

    if (upsellCardCont.length > 0) {
      // Find the div with class lb-spc-details-name containing "Comfort"
      const comfortDiv = upsellCardCont.find('.lb-spc-details-name:contains("Comfort")');

      if (comfortDiv.length > 0) {
        // Append a div with class upsell-card-desc containing "+50 Pee Pads" and "+3 Classic Mats"
        const upsellCardDescDiv = $('<div class="upsell-card-desc">+50 Pee Pads<br>+3 Classic Mats</div>');
        comfortDiv.after(upsellCardDescDiv);
      }

      // Find the div with class lb-spc-details-name containing "Deluxe"
      const deluxeDiv = upsellCardCont.find('.lb-spc-details-name:contains("Deluxe")');

      if (deluxeDiv.length > 0) {
        // Append a div with class upsell-card-desc containing "+100 Pee Pads" and "+5 Classic Mats"
        const upsellCardDescDivDeluxe = $('<div class="upsell-card-desc">+100 Pee Pads<br>+5 Classic Mats</div>');
        deluxeDiv.after(upsellCardDescDivDeluxe);
      }
      
      // Stop further execution as the target div is found
      return;
    }
  }

  // Check if the maximum attempts (3 times) have been reached
  if (executeScript.attempts >= 3) {
    console.log('Script execution stopped. The div .lb-upsell-ppa-card-cont was not found.');
    return;
  }

  // Increment attempts count
  executeScript.attempts++;

  // Execute the script again after 2 seconds
  setTimeout(executeScript, 2000);
}

// Initialize attempts count
executeScript.attempts = 0;

// Call the function to execute the script
executeScript();